import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import Input from "@murphy-frontend/web-core/components/Input";
import Textarea from "@murphy-frontend/web-core/components/TextArea";

interface MBSMessageEditorProps {
  message: string;
  title: string;
  question?: string;
  showQuestionEditor: boolean;
  handleQuestionChange: any;
  handleMessageBodyChange: any;
  handleMessageTitleChange: any;
  messageQuestionError: string;
  messageBodyError: string;
  messageTitleError: string;
  placeholdertext?: string;
  rows: number;
  cols: number;
  showNoOfSms: boolean;
  translations: Record<string, string>;
}

const styles = {
  row: {
    display: 'flex',
    width: '80rem'
  },
  input: {
    borderWidth: 1,
    borderColor: '#EBEBEB',
    borderStyle: 'solid',
    borderRadius: 5,
    width: '60rem'
  },
  label: {
    width: '10rem',
    color: '#626262'
  },
  required: {
    width: '10rem',
    color: '#626262',
    fontSize: 10,
    fontStyle: 'italic'
  }
}

const MBSMessageEditor: FunctionComponent<MBSMessageEditorProps> = ({
  message,
  title,
  question,
  showQuestionEditor,
  handleQuestionChange,
  handleMessageBodyChange,
  handleMessageTitleChange,
  messageQuestionError,
  messageBodyError,
  messageTitleError,
  placeholdertext,
  rows,
  cols,
  showNoOfSms,
  translations,
}) => {
  const messageInfoMessages = [];

  if (message) {
    const charsPrinted = message.length;
    const charsPerSMS = 160;
    const noOfSms = Math.ceil(charsPrinted / charsPerSMS);
    messageInfoMessages.push(
      `${translations.numberofcharacters}: ${charsPrinted}`
    );
    if (showNoOfSms) {
      messageInfoMessages.push(`${translations.numberof} SMS:  ${noOfSms}`);
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: 20, paddingRight: 20, marginTop: 20 }}>
      <label style={{ fontSize: '18px', marginBottom: 20, color: 'grey', marginTop: 20, display: 'flex' }}>{translations.composemsg || "Compose your message"}</label>
      <div style={styles.row}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={styles.label}>{translations.title}</span>
          <span style={styles.required}>{translations.required || "required"}</span>
        </div>

        <Input
          val={title}
          isRequired
          style={styles.input}
          handleChange={handleMessageTitleChange}
          errorMessage={messageTitleError}
          placeholder={translations.thistextwillnotshowinsms}
        />
      </div>
      <div style={styles.row}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={styles.label}>{translations.message}</span>
          <span style={styles.required}>{translations.required || "required"}</span>
        </div>
        <Textarea
          title={""}
          val={message}
          style={styles.input}
          isRequired
          handleChange={handleMessageBodyChange}
          errorMessage={messageBodyError}
          infoMessages={messageInfoMessages}
          rows={rows}
          cols={cols}
          placeholder={placeholdertext}
        />
      </div>
      {showQuestionEditor ? (<div style={styles.row}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={styles.label}>{translations.question}</span>
          <span style={styles.required}>{translations.required || "required"}</span>
        </div>
        <Textarea
          title={""}
          val={question}
          style={styles.input}
          isRequired
          handleChange={handleQuestionChange}
          errorMessage={messageQuestionError}
          rows={rows}
          cols={cols}
          placeholder={placeholdertext}
        />
      </div>) : null}
    </div>
  );
};

MBSMessageEditor.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  question: PropTypes.string,
  messageTitleError: PropTypes.string,
  messageBodyError: PropTypes.string,
  messageQuestionError: PropTypes.string,
  showQuestionEditor: PropTypes.bool,
  placeholdertext: PropTypes.string,
  rows: PropTypes.number.isRequired,
  cols: PropTypes.number.isRequired,
  handleMessageBodyChange: PropTypes.func.isRequired,
  handleMessageTitleChange: PropTypes.func.isRequired,
  handleQuestionChange: PropTypes.func,
  showNoOfSms: PropTypes.bool,
};

MBSMessageEditor.defaultProps = {
  title: '',
  message: '',
  question: '',
  placeholdertext: '',
  messageTitleError: '',
  messageBodyError: '',
  messageQuestionError: '',
  showQuestionEditor: false,
  handleQuestionChange: null,
  showNoOfSms: false,
};

export default MBSMessageEditor;
